<template>
  <v-card class="rounded-lg pa-2 white" flat >

    <v-card-title class="secondary--text mb-3">
      نسبت گردش دارایی ( <span class="ml-1 mr-1 success--text">بهره وری</span> )

      <v-spacer></v-spacer>
      <chart-export-btn page-chart-id="m-p-m-chart"></chart-export-btn>

    </v-card-title>
    <canvas height="120" id="m-p-m-chart"></canvas>
  </v-card>
</template>

<script>
import Chart from 'chart.js'
import ChartExportBtn from "@/components/scomponents/ChartExportBtns";

export default {
  name: 'MonthProfitMarginChart',
  components: {ChartExportBtn},
  data() {
    return {
      chartData: {
        type: "line",
        data: {
          labels: [],
          datasets: [
            {
              label: "نسبت گردش دارایی",
              data: [],
              backgroundColor: "rgba(50, 168, 82,.04)",
              borderColor: "#50CD89",
              borderWidth: 3,
              hoverBorderWidth: 5,

            },
          ]
        },

        options: {
          title: {
            display: true,
            text: '',
            fontColor: "#000",
            fontSize: 18,
          },
          responsive: true,
          legend: {
            display: false
          },
          interaction: {
            intersect: true,
            mode: 'index',
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: false,
              }
            }],
            yAxes: [
              {
                display: true,
                gridLines: {
                  color: "rgba(161, 161, 161, .08)",
                },
                ticks: {
                  beginAtZero: true,
                  padding: 15
                }
              }
            ]
          }
        }
      }
    }
  },
  mounted() {
    this.request({
      url: this.endpoint(`reports/marginProfitChartReport`),
      method: "get",
      success: data => {
        this.getData(data)
      }
    })
  },
  methods: {
    getData(data) {
      this.chartData.options.title.text = 'شرکت ' + this.company.name + '  سال مالی ' + this.financialYear.name
      this.chartData.options.title.fontSize =  15
      this.chartData.data.labels = []
      this.chartData.data.datasets[0].data = []
      for (let month of data){
        this.chartData.data.labels.push(month.title)
        this.chartData.data.datasets[0].data.push(month.amount)
      }
      this.getChart()
    },
    getChart(){
      const ctx = document.getElementById('m-p-m-chart');
      new Chart(ctx, this.chartData);
    }
  },
}
</script>

